import styled from 'styled-components';
import CardDisplay from 'components/common/Card';

export const MarginBottom = styled.div`
  margin-bottom: 16px;
`;

export const MarginTop = styled.div`
  margin-top: 16px;
`;

export const Container = styled.div`
  flex: 1;
  margin: 0px 8px;

  ${props => props.theme.media.sm.max`
    margin: 0px !important;
  `}
`;

export const Padding = styled.div`
  padding: 16px;
`;


export const ContentContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const InnerContain = styled.div`
  flex: 1;
  max-width: 1600px;
  margin-top: calc(88px + 24px);

  ${(props) => props.theme.media.sm.max`
    width: 100%;
    margin-top: 0px !important;
    padding-left: 0px !important;
    padding-right: 0px !important;
  `}

  ${(props) => props.theme.media.xl.max`
    max-width: 1366px;
    margin-top: calc(88px + 16px);
  `}

  ${(props) => props.theme.media.md.max`
    padding-left: 16px;
    padding-right: 16px;
  `}

  ${(props) => props.theme.media.lg.max`
    max-width: 1024px;
  `}
`;


export const FlexContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0px -8px;

  ${props => props.theme.media.sm.max`
    flex-direction: column;
    padding-bottom: 8px;
    margin: 0px !important;
  `}
`;

export const stripeAddCardStyles = {
  base: {
    color: '#32325d',
    lineHeight: '1.2em',
    fontFamily: 'Roboto, Helvetica, sans-serif',
    fontSmoothing: 'antialiased',
    fontSize: '1.5em',
    '::placeholder': {
      color: '#aab7c4'
    }
  },
  invalid: {
    color: '#fa755a',
    iconColor: '#fa755a'
  }
};

export const CardText = styled.div`
  font-size: 1.0em;
  font-family: Roboto;
  color: #0f5680;
`;

export const CardContainer = styled.div`
  padding: 24px;
  border-width: 1px;
  border-radius: 2px;
  border-style: solid;
  border-color: #e6f1f8;
  background-color: #fafcfe;

  ${props => props.flex && `
    display: flex;
    justify-content: space-between;
  `}
`;

export const Card = styled(CardDisplay.Content)`
  ${props => props.theme.media.sm.max`
    padding: 24px !important;
  `}
`;

export const CardContain = styled.div`
  margin-bottom: 16px;

  ${props => props.theme.media.sm.max`
    margin-bottom: 0px;
  `}
`;
